import styled from 'styled-components'

export const Overlay = styled.div`
   position: fixed;
   inset: 0;
   background: rgba(0,0,0,0.32);
   z-index: 140;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 32px 20px;
`

export const Dialog = styled.div`
   max-width: 40%;
   background: #FFFFFF;
   border-radius: 16px;
   box-shadow: 0 12px 40px -8px rgba(16,24,40,0.14);
   display: flex;
   flex-direction: column;
   max-height: 100%;
   overflow: hidden;
`

export const Header = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 20px 18px 10px 18px;

   h2 {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
      color: #101018;
   }

   button {
      background: none;
      border: 0;
      font-size: 22px;
      cursor: pointer;
      line-height: 1;
      color: #3F3F45;
      padding: 6px;
   }
`

export const Body = styled.div`
   padding: 0 18px 18px 18px;
   color: #9C9C9F;
   font-size: 14px;
   line-height: 28px;
`

export const Divider = styled.div`
   background: #F5F5F6;
   margin-top: 10px;
`

export const Inputs = styled.div`
   gap: 16px;
   display: flex;
   margin-top: 16px;
   justify-content: center;
`

interface BoxProps { $active?: boolean; $error?: boolean }
export const Box = styled.div<BoxProps>`
   border-radius: 8px;
   background: #FFFFFF;
   transition: border 0.2s ease;
   border: ${p => p.$error ? '2px solid #DD524D' : (p.$active ? '2px solid #AF7AD5' : '1.6px solid #EDEDEE')};
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 20px 22px;
   box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.02);
   position: relative;
`

export const Dot = styled.div`
   width: 8px;
   height: 8px;
   background: #101018;
   border-radius: 99px;
`

export const PinInput = styled.input`
   position: absolute;
   inset: 0;
   width: 0;
   height: 0;
   border: 0;
   outline: none;
   background: transparent;
   color: transparent;
   caret-color: transparent;
   text-align: center;
`

export const Footer = styled.div`
   display: flex;
   justify-content: flex-end;
   gap: 12px;
   padding: 14px 18px 18px 18px;
   background: #FAFAFB;

   button {
      padding: 10px 24px;
      border-radius: 999px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;

      &.cancel {
         background: #F5F5F6;
         color: #3F3F45;
         border: 0;
         &:hover { background: #EDEDEE; }
      }

      &.confirm {
         background: #AF7AD5;
         color: #FFFFFF;
         border: 0;
         opacity: 0.6;
         cursor: not-allowed;
   
         &.enabled {
            opacity: 1;
            cursor: pointer;
            &:hover { background: #9b63c9; }
         }
      }
   }
`

export const ErrorText = styled.div`
   color: #DD524D;
   font-size: 14px;
   margin-top: 8px;
   ${p => p.className = 'text-center'}
`
